import { render, staticRenderFns } from "./Washroomscore.vue?vue&type=template&id=5b563a4d&scoped=true&"
import script from "./Washroomscore.vue?vue&type=script&lang=js&"
export * from "./Washroomscore.vue?vue&type=script&lang=js&"
import style0 from "./Washroomscore.vue?vue&type=style&index=0&id=5b563a4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b563a4d",
  null
  
)

export default component.exports